import React from 'react';
import { Field, getFormValues } from 'redux-form';
import { connect } from 'react-redux';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';

import { GetDateFormat } from '../../lib/date';
import { NextBillingDateSelect } from './';

let InputRadioWithSelect = ({ input, values, min, radioName, activeDate, option1, defaultDate, translate, NextBillingDate, hasFutureFreeze, meta: { touched, error } }) => {
  const notChange = hasFutureFreeze ?
    <label className="custom-control custom-radio">
      <input {...input} className="custom-control-input" type="radio" name={radioName} value={defaultDate} checked={values[radioName] === defaultDate}/>
      <span className="custom-control-indicator"></span>
      <span className="custom-control-description">{`${translate('do-not-change')} (${GetDateFormat(defaultDate)})`}</span>
    </label>
    :
    '';
  return (
    <div className="form-group row">
    {touched && error && <div><span className="text-danger">{error}</span></div>}
      <div className="col">
        <div className="custom-controls">
        {notChange}
            <label className="custom-control custom-radio col-sm-row">
              <input {...input} className="custom-control-input" type="radio" name={radioName} checked={values[radioName] !== defaultDate}/>
              <span className="custom-control-indicator custom-control-indicator-center"></span>
              <span className="">
                <Field radioName={radioName} name={radioName} translate={translate} className="form-control" component={NextBillingDateSelect} NextBillingDate={NextBillingDate} type="date" />
              </span>
            </label>
        </div>
      </div>
    </div>

  );
}

const viewMapStateToProps = (state) => {
  return {
    translate: getTranslate(state.locale),
    currentLanguage: getActiveLanguage(state.locale).code,
    values: getFormValues('Freeze')(state) ||{},
  }
}

const viewMapDispatchToProps = (dispatch) => {
  return {
  };
};

InputRadioWithSelect = connect(
  viewMapStateToProps,
  viewMapDispatchToProps,
)(InputRadioWithSelect);

export default InputRadioWithSelect;



// WEBPACK FOOTER //
// ./src/components/Freeze/InputRadioWithSelect.js